import React from "react";
import "./SubAccountView.scss";
import moment from "moment-timezone";
import { ReactTable } from "../../SimpleForm/ReactTable";

const columns = [
  {
    Header: "Account Linking Information",
    accessor: "AccountInfo",
    Cell: ({ value }) => {
      return (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <span>{value.Value}</span>
          <span>{value.Key}</span>
        </div>
      );
    }, // // String-based value accessors!
  },
];

const SubAccountView = ({ myGroup, currentUser }) => {
  const options = {
    minRows: 0,
    showPagination: false,
    defaultPageSize: 5,
    showPaginationBottom: false,
    pageSizeOptions: [5, 10, 20, 25, 50, 100],
  };

  let inviter = "N/A";
  myGroup.Invitation.forEach((invite) => {
    if (invite.recipientEmail === currentUser.email) {
      inviter = invite.firstName + " " + invite.lastName;
    }
  });

  let groupData = [
    {
      AccountInfo: {
        Key: "Legal Business Name",
        Value: myGroup.label || "N/A",
      },
    },
    { AccountInfo: { Key: "FEIN", Value: myGroup.fein || "N/A" } },
    {
      AccountInfo: {
        Key: "Date Join",
        Value:
          moment
            .tz(new Date(myGroup.createdAt), "America/New_York")
            .format("MMM D YYYY") || "N/A",
      },
    },
    { AccountInfo: { Key: "Invited By", Value: inviter } },
  ];

  return (
    <div>
      <div className="header-container">
        <div className="header-content">
          <div className="usa-content-header">
            <div className="usa-header-profile">
              <h3 className="usa-flag-page-header">My Network</h3>
              <p className="headerInfo">
                {" "}
                Link yourself to a network where you can share cases and
                profiles across accounts
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="content-container">
        <ReactTable
          tableTheme="genericTheme"
          data={groupData}
          columns={columns}
          options={options}
        />
      </div>
    </div>
  );
};

export default SubAccountView;
